// Auto-sends the message the user queued while a turn was still running.
// Mounted once in the AgentForge umbrella. Fires only for the ACTIVE
// session when its tab leaves 'streaming' cleanly ('done') — an errored
// turn keeps the queue parked so the failure strip stays the next action,
// and a background session's queue waits until the user returns to it
// (send() always targets the active session).

import { useEffect } from 'react';
import { useAgentForgeStore } from '../stores';
import { useChatSubmit } from './useChatSubmit';

export const useQueuedSendDispatcher = (): void => {
  const { send } = useChatSubmit();
  const tabStatus = useAgentForgeStore(
    (s) => s.openTabs.find((t) => t.sessionId === s.activeSessionId)?.status
  );
  const queued = useAgentForgeStore((s) =>
    s.activeSessionId ? s.queuedBySession[s.activeSessionId]?.[0] : undefined
  );

  useEffect(() => {
    if (tabStatus !== 'done' || !queued) return;
    const state = useAgentForgeStore.getState();
    const sid = state.activeSessionId;
    if (!sid) return;
    void send(queued.text, queued.files, {
      selectionSnapshot: queued.selections,
      queuedTurn: queued,
    });
  }, [tabStatus, queued, send]);
};
